<template>
    <form id="formAddTraining"
          action=""
          class="card border-0 bg-transparent"
          method="post"
          @submit.prevent="addTraining">

        <!-- Title -->
        <section-headline :msg="headline"></section-headline>
        <!-- End Title -->

        <!-- Is Individual Training Checkbox -->
        <div class="row my-3 m">
            <div class="col-md-6">
                <div class="form-froup">
                    <div class="form-check">
                        <input id="individualTraining"
                               v-model="individualTraining"
                               class="form-check-input"
                               type="checkbox">
                        <label class="form-check-label"
                               for="individualTraining">Individuelles Training</label>
                    </div>
                </div>

            </div>
        </div>
        <!-- End Is Individual Training Checkbox -->

        <div class="row mb-3">
            <div class="col-md-12">
                <div class="form-group pb-0 mb-0">
                    <div class="form-row">
                        <!-- Trainings Select -->
                        <div v-if="!this.individualTraining "
                             :class="[this.formOptions.case === 'merchant' ? 'col-md-12' : 'col-md-8']"
                             class="form-group">
                            <label>Training auswählen*</label>
                            <!-- Loading Trainings Indicator -->
                            <div v-if="isDataLoaded" class="multiselect">
                                <div class="multiselect__tags d-flex align-items-center p-1">
                                    <i class="fa fa-spinner fa-spin fa-2x fa-fw mr-1"></i>
                                    <p class="m-0">Trainings werden geladen!</p>
                                </div>
                            </div>
                            <!-- End Loading Trainings Indicator -->

                            <!-- Training Dropdown -->
                            <div v-else>
                                <multiselect ref="trainingSelect"
                                             v-model.lazy="form.trainingsOptionValue"
                                             :class="{ 'border border-danger': shouldAppendErrorClass($v.form.trainingSelect), 'border border-success': shouldAppendValidClass($v.form.trainingSelect)}"
                                             :clear-on-select="false"
                                             :close-on-select="false"
                                             :custom-label="numberWithName"
                                             :multiple="true"
                                             :option-height="90"
                                             :options="form.trainingsOptions"
                                             :searchable="true"
                                             deselectLabel=""
                                             group-label="category"
                                             group-values="trainings"
                                             label="name"
                                             placeholder="Training auswählen"
                                             selectLabel=""
                                             selectedLabel=""
                                             track-by="name">
                                    <template
                                        slot="option"
                                        slot-scope="props">
                                        <div v-if="props.option.$groupLabel">
                                            <span class="option__title">
                                                {{ props.option.$groupLabel }}
                                            </span>
                                        </div>
                                        <div v-else
                                             class="option__desc d-flex flex-column">
                                                    <span class="option__title mb-3">
                                                        <strong><u>{{ props.option.trainings_number
                                                            }} - {{ props.option.name }}</u></strong>
                                                    </span>
                                            <span class="option__description">
                                                        {{ props.option.description }}
                                                    </span>
                                        </div>
                                    </template>
                                </multiselect>
                                <small v-if="$v.form.trainingSelect.$error"
                                       class="text-danger">Bitte ein Training auswählen!</small>
                            </div>
                            <!-- End Training Dropdown -->
                        </div>
                        <!-- End Trainings Select -->

                        <!-- Individual Input -->
                        <div v-if="this.individualTraining"
                             :class="[this.formOptions.case === 'merchant' ? 'col-md-12' : 'col-md-8']"
                             class="form-group">

                            <!-- Individual Input Label -->
                            <label for="trainingIndividual">Individuelles Training:*</label>
                            <!-- End Individual Input Label -->

                            <!-- Individual Input Field -->
                            <input id="trainingIndividual"
                                   v-model.lazy="$v.form.trainingIndividual.$model"
                                   :class="{ 'border border-danger': shouldAppendErrorClass($v.form.trainingIndividual), 'border border-success': shouldAppendValidClass($v.form.trainingIndividual)}"
                                   class="form-control"
                                   name="trainingIndividual"
                                   placeholder="Individuelles Training">
                            <!-- Individual Input Field -->

                            <!-- Individual Input Errors -->
                            <div v-if="$v.form.trainingIndividual.$error && $v.form.trainingIndividual.$dirty">
                                <small v-if="!$v.form.trainingIndividual.required"
                                       class="text-danger">Bitte einen Text
                                    eingeben.</small>
                                <small v-else-if="!$v.form.trainingIndividual.minLength"
                                       class="text-danger">Der Text muss mindestens 5
                                    Zeichen besitzen.</small>
                                <small v-else-if="!$v.form.trainingIndividual.maxLength"
                                       class="text-danger">Der Text darf nicht mehr als 50
                                    Zeichen besitzen.</small>
                            </div>
                            <!-- End Individual Input Errors -->
                        </div>
                        <!-- End Individual Input -->

                        <!-- Attendees Input -->
                        <div v-if="this.formOptions.case === 'employee'"
                             class="form-group col-md-4">
                            <!-- Attendees Input Label -->
                            <label for="trainingsNumber">Personenanzahl</label>
                            <!-- End Attendees Input Label -->

                            <!-- Attendees Input Field -->
                            <input id="trainingsNumber"
                                   v-model.lazy="$v.form.trainingAttendeesNumber.$model"
                                   :class="{ 'border border-danger': shouldAppendErrorClass($v.form.trainingAttendeesNumber), 'border border-success': shouldAppendValidClass($v.form.trainingAttendeesNumber)}"
                                   class="form-control min-height"
                                   type="number">
                            <!-- End Attendees Input Field -->

                            <!-- Attendees Input Errors-->
                            <div v-if="$v.form.trainingAttendeesNumber.$error">
                                <small v-if="!$v.form.trainingAttendeesNumber.required"
                                       class="text-danger">Bitte die Personenanzahl
                                    angeben.</small>
                                <small v-else-if="!$v.form.trainingAttendeesNumber.between"
                                       class="text-danger">Die Zahl muss zwischen 1
                                    und 50 sein.</small>
                                <small v-else-if="$v.form.trainingAttendeesNumber.integer"
                                       class="text-danger">Bitte nur ganze Zahlen
                                    eingeben.</small>
                            </div>
                            <!-- End Attendees Input Errors -->
                        </div>
                        <!-- End Attendees Input -->

                        <!-- Textbox -->
                        <div class="form-group col-md-12 mb-0">
                            <!-- Textbox  Label -->
                            <label :class="{ 'text-danger': shouldAppendErrorClass($v.form.trainingComment) }"
                                   for="trainingComment"
                            >Kommentar: <small
                                v-if=" this.form.trainingComment.length > 0">({{ this.form.trainingComment.length }} /
                                150 Zeichen)</small></label>
                            <!-- End Textbox Label -->

                            <!-- Textbox Input -->
                            <textarea id="trainingComment"
                                      v-model="$v.form.trainingComment.$model"
                                      :class="{ 'border border-danger': shouldAppendErrorClass($v.form.trainingComment), 'border border-success': shouldAppendValidClass($v.form.trainingComment)}"
                                      class="form-control"
                                      cols="30"
                                      name="trainingComment"
                                      rows="3"
                            ></textarea>
                            <!-- End Textbox Input -->

                            <!-- Textbox Errors -->
                            <small v-if="!$v.form.trainingComment.maxLength"
                                   class="text-danger">Es sind nicht mehr als 150 Zeichen
                                erlaubt.</small>
                            <!-- End Textbox Errors -->
                        </div>
                        <!-- End Textbox -->
                    </div>
                </div>
            </div>
        </div>

        <!-- Submit Button -->
        <div class="row mt-0 mt-md-2">
            <div class="col d-flex justify-content-end">
                <button :disabled="$v.form.$invalid || this.sendingEmail"
                        class="btn btn-success " type="submit">
                    <i v-if="!this.sendingEmail" class="fas fa-plus mr-1"></i>
                    <i v-if="this.sendingEmail" class="fa fa-spinner fa-spin fa-fw mr-1"></i>Hinzufügen
                </button>
            </div>
        </div>
        <!-- End Submit Button -->
    </form>
</template>
<style scoped>
.option__description {
    white-space: normal !important;
    line-height: 1.5rem;
}

.min-height {
    min-height: 44px;
}
</style>
<script>

import {between, integer, maxLength, minLength, required, requiredIf} from 'vuelidate/lib/validators';

export default {
    name: 'SignupFormBuilder',

    props: {
        formOptions: null,
        sendingEmail: null,
        headline: String,
    },

    data: function() {
        return {
            form: {
                trainingSelect: 0,
                trainingAttendeesNumber: 1,
                trainingIndividual: null,
                trainingsOptions: this.formOptions.trainings,
                trainingComment: '',
                trainingsOptionValue: [],
            },
            individualTraining: false,
        };
    },

    validations: {
        form: {
            trainingSelect: {
                required: requiredIf(function() {
                    return !this.individualTraining;
                }),
            },
            trainingAttendeesNumber: {
                required,
                integer,
                between: between(1, 50),
            },
            trainingIndividual: {
                required: requiredIf(function() {
                    return this.individualTraining;
                }),
                minLength: minLength(5),
                maxLength: maxLength(50),
            },
            trainingComment: {
                maxLength: maxLength(150),
            },
            trainingsOptionValue: {
                required: requiredIf(function() {
                    return !this.individualTraining;
                }),
            },
        },
    },

    mounted() {
        //this.form.trainingsOptionValue.push(this.form.trainingsOptions[0]['trainings'][0]);
    },

    computed: {
        isDataLoaded: function() {
            return this.form.trainingsOptions === 0;
        },
    },

    methods: {
        numberWithName({trainings_number, name}) {
            return `${trainings_number} - ${name}`;
        },
        shouldAppendValidClass(field) {
            return !field.$invalid && field.$model && field.$dirty;
        },
        shouldAppendErrorClass(field) {
            return field.$error;
        },
        addTraining: function() {
            let trainings = [];

            if (this.individualTraining) {
                trainings.push({
                    'unique_id': Math.random() * 100,
                    'type': this.formOptions.case,
                    'trainingsText': this.form.trainingIndividual,
                    'trainingsId': null,
                    'isIndividual': this.individualTraining,
                    'attendees': this.form.trainingAttendeesNumber,
                    'comment': this.form.trainingComment,
                });
            } else {
                this.form.trainingsOptionValue.forEach((element) => {
                    trainings.push({
                        'unique_id': Math.random() * 100,
                        'type': this.formOptions.case,
                        'trainingsText': element.name,
                        'trainingsId': element.id,
                        'isIndividual': false,
                        'attendees': this.form.trainingAttendeesNumber,
                        'comment': this.form.trainingComment,
                    });
                });
            }

            if (this.$v.form.invalid) {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Es ist ein Fehler aufgetreten',
                    showConfirmButton: false,
                    timer: 5000,
                });
            }

            this.$emit('addTrainingData', trainings);
            this.form.trainingIndividual = '';
            this.form.trainingsOptionValue = [];
            this.form.trainingComment = '';
            this.$v.form.$reset();
        },
    },
};
</script>
